import { Badge2 } from "@/ui2/atoms/Badge";
import { IdentityDocumentPreviewButton } from "./IdentityDocumentPreviewButton";
import type { UUID } from "@/core/types";

type IdentityDocumentEditModeProps = {
  personalIdFront?: string;
  entityId?: never;
  isDisabled: true;
};

type IdentityDocumentViewModeProps = {
  personalIdFront?: string;
  entityId: UUID;
  isDisabled?: never;
};

type IdentityDocumentProps = IdentityDocumentEditModeProps | IdentityDocumentViewModeProps;

export function IdentityDocument({ personalIdFront, entityId, isDisabled }: IdentityDocumentProps) {
  const isUploaded = Boolean(personalIdFront);

  return (
    <dl className="tw:text-sm tw:flex tw:flex-col tw:gap-2">
      <dt className="tw:font-bold ">Identity Document</dt>
      <dd className="tw:mb-0!">
        {isUploaded ? (
          <IdentityDocumentPreviewButton entityId={entityId} isDisabled={isDisabled} />
        ) : (
          <Badge2 variant="outline-neutral">Not Uploaded</Badge2>
        )}
      </dd>
    </dl>
  );
}
